import { Action } from '../../common/actions/core/action';

export class ChangePaymentResultAction implements Action {
  constructor(public paymentMethodId: number, public updateSubscription: boolean, public cardId: string) {}
}



// WEBPACK FOOTER //
// src/app/buy/change-payment-result-dialog/change-payment-result.action.ts